import React, { useState, useRef } from 'react';import './Services.css';
import { imagenesServicios } from "../../utils/diccionarioImagenes";

// import svgTituloServices from "../../assets/services/servicios_titulo_pagina.svg";
import svgTituloServices from "../../assets/services/Curva3.svg";

import ContactForm from "../../secciones/ContactForm/ContactForm";


const Services = () => {

  const [servicioSeleccionadoId, setServicioSeleccionadoId] = useState(null);
  const formRef = useRef(null);

  const serviceData = [
    {
      id: 1,
      gridType: "grid-six",
      options: [
        {
          title: "Diseño de Modelos de Gestión del Aprendizaje",
          info: `Diseñamos modelos estructurados de gestión del aprendizaje que definen cómo planificar, ejecutar y medir la formación, alineándola a la estrategia del negocio y potenciando el desarrollo del talento con metodologías innovadoras.`
        },
        {
          title: "Desarrollo de Capabilities",
          info: `Desarrollamos capacidades organizacionales clave, integrando conocimientos, habilidades, procesos y cultura, para fortalecer competencias críticas del negocio e impulsar el desempeño, la innovación y el crecimiento sostenible.`
        },
        {
          title: "Creación de Universidades Corporativas",
          info: `Diseñamos universidades corporativas alineadas a la estrategia del negocio, estructurando rutas de aprendizaje que fortalecen competencias, aceleran el desarrollo del talento y aseguran crecimiento sostenible.`
        },
        {
          title: "Desarrollo de programas, talleres y recursos de aprendizaje",
          info: `Diseñamos programas formativos a medida, talleres experienciales
          y recursos de aprendizaje prácticos. Integramos metodologías activas,
          casos reales y herramientas digitales. Aseguramos experiencias de
          aprendizaje efectivas y aplicables al día a día laboral.`
        },
        {
          title: "Academias y Mallas Organizacionales",
          info: `Diseñamos academias y mallas organizacionales que estructuran el aprendizaje por roles y niveles, fortaleciendo competencias clave y asegurando el desarrollo continuo del talento alineado al negocio.`
        },
        {
          title: "Onboarding Cultural y al Puesto",
          info: `Diseñamos procesos de integración al puesto y a la cultura organizacional que permiten al talento adaptarse rápidamente, comprender su rol y alinearse con los valores y objetivos de la empresa desde el inicio.`
        }
      ]
    },

    {
      id: 2,
      gridType: "grid-five",
      options: [
        {
          title: "Programas de Transformación Cultural",
          info: `Diseñamos programas de transformación cultural que alinean comportamientos y valores con la estrategia del negocio, fortaleciendo el compromiso, la adaptación al cambio y el logro de resultados sostenibles.`
        },
        {
          title: "Desarrollo de Estrategias de Gestión del Cambio",
          info: `Diseñamos estrategias de gestión del cambio que facilitan la adopción de nuevas iniciativas, reducen la resistencia y aseguran una transición efectiva, alineando a las personas con los objetivos del negocio.`
        },
        {
          title: "Implantación de Estrategias de Diversidad e Inclusión",
          info: `Implementamos estrategias de diversidad e inclusión que promueven entornos equitativos y respetuosos, fortaleciendo la cultura organizacional, el compromiso del talento y la innovación.`
        },
        {
          title: "Acciones e Iniciativas de Sensibilización",
          info: `Diseñamos acciones e iniciativas de sensibilización que promueven conciencia, cambio de actitudes y comportamientos, fortaleciendo la cultura organizacional y el compromiso del talento.`
        },
        {
          title: "Mediciones de Clima y Cultura Organizacional",
          info: `Realizamos mediciones de clima y cultura organizacional que brindan información clave para la toma de decisiones, identificando oportunidades de mejora y fortaleciendo el bienestar y compromiso del talento.`
        }
      ]
    },

    {
      id: 3,
      gridType: "grid-seven",
      options: [
        {
          title: "Estrategias de Liderazgo",
          info: `Diseñamos estrategias de liderazgo que fortalecen habilidades clave, alinean a los líderes con la cultura y objetivos del negocio, y potencian el desempeño, la toma de decisiones y el desarrollo de equipos.`
        },
        {
          title: "Leadership Capabilities",
          info: `Desarrollamos capacidades de liderazgo que integran habilidades, comportamientos y mentalidad, fortaleciendo la toma de decisiones, la gestión de equipos y el logro de resultados alineados al negocio.`
        },
        {
          title: "Programas de Formación a Líderes",
          info: `Diseñamos programas de formación para líderes que desarrollan habilidades clave, fortalecen la toma de decisiones y potencian la gestión de equipos, alineando el liderazgo con los objetivos del negocio.`
        },
        {
          title: "Coaching & Mentoring",
          info: `Diseñamos procesos de coaching y mentoring que potencian el desarrollo individual, fortalecen habilidades clave y acompañan el crecimiento profesional, alineando el talento con los objetivos del negocio.`
        },
        {
          title: "Gestión del Desempeño",
          info: `Diseñamos sistemas de gestión del desempeño que alinean objetivos, evalúan resultados y desarrollan talento, impulsando la mejora continua, la productividad y el logro de metas del negocio.`
        },
        {
          title: "Mapeo y Desarrollo de Talento",
          info: `Identificamos talento clave y potencial dentro de la
          organización. Diseñamos planes de desarrollo personalizados.
          Aseguramos continuidad y crecimiento interno del talento.`
        },
        {
          title: "Planes de Sucesión y Carrera",
          info: `Diseñamos planes de sucesión que identifican y preparan reemplazos para puestos clave ante salidas o cambios, asegurando continuidad operativa, y planes de carrera que guían el desarrollo y crecimiento del talento dentro de la organización.`
        }
      ]
    }
  ];

  const handleConsultar = (idServicio) => {
    console.log("serviceId:", idServicio)
    setServicioSeleccionadoId(idServicio);
    if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <section className="service-section section-green" id="service-section">
      <div className="container">

        {/* TÍTULO SVG */}
        <div className="banner-svg-container">
          <div className="svg-wrapper">
            <img
              src={svgTituloServices}
              alt="Servicios"
              className="img-svg-titulo"
            />
          </div>
        </div>

        {serviceData.map((service) => (
          <div key={service.id} className="service-block">
            
            {/* IMAGEN DE FONDO (TÍTULO DEL SERVICIO) */}
            <div
              className="background-image-wrapper"
              style={{ backgroundImage: `url(${imagenesServicios[service.id]})` }}
            />

            {/* GRILLA DE OPCIONES */}
            <div className={`options-grid ${service.gridType}`}>
              {service.options.map((option, optIndex) => (
                <div key={optIndex} className="option-box">
                  {option.title}
                  <div className="option-tooltip">
                    {option.info}
                  </div>
                </div>
              ))}
            </div>

            {/* BOTÓN CONSULTAR */}
            <div className="service-cta">
              <button 
                className="button button-main" 
                style={{ color: '#0f4f4f' }} 
                onClick={() => handleConsultar(service.id)}
              >
                Consultar
              </button>
            </div>

          </div>
        ))}
      </div>

      <div ref={formRef}>
        <ContactForm preselectedServiceId={servicioSeleccionadoId} />
      </div>
    </section>
  );
};

export default Services;